import { z } from 'zod'

/**
 * Filtros da listagem `/produtos`. Ficam na URL da loja (`useProductFilters`) e vão para a API serializados dentro do
 * parâmetro `term` de `product/list-products` (`buildProductListTerm`). A API filtra: `term` (texto normalizado),
 * `category`, `size` (tamanho do produto), `feature` (tags), `color` (atributos), `seller`, `manufacturer`, faixa de
 * preço e ordenação. Categorias, tamanhos, cores e características não vêm da API: são listas fixas
 * (`constants/catalog.ts`).
 */

/** Campos de ordenação que a API aceita em `orderBy`; outro valor cai na ordem de exibição. */
export const PRODUCT_SORT_FIELDS = ['price', 'discountedPrice', 'name', 'order', 'createDate', 'stockQuantity'] as const

export const ProductFiltersSchema = z.object({
    term: z.string(),
    category: z.array(z.string()),
    feature: z.array(z.string()),
    color: z.array(z.string()),
    size: z.array(z.string()),
    seller: z.array(z.string()),
    manufacturer: z.array(z.string()),
    priceFrom: z.number().min(0).nullable(),
    priceTo: z.number().min(0).nullable(),
    order: z.enum(['asc', 'desc']).nullable(),
    orderBy: z.enum(PRODUCT_SORT_FIELDS).nullable(),
})

export type IProductFilters = z.infer<typeof ProductFiltersSchema>
export type IProductSortOrder = NonNullable<IProductFilters['order']>
export type IProductSortField = NonNullable<IProductFilters['orderBy']>
/** Filtros de lista (multisseleção). */
export type IProductListFilterKey = 'category' | 'feature' | 'color' | 'size' | 'seller' | 'manufacturer'
